var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFigmaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.75C17.7418 3.75 19.1726 4.34263 20.2275 5.39752C21.2824 6.45242 21.875 7.88316 21.875 9.375C21.875 10.8668 21.2824 12.2976 20.2275 13.3525C19.1726 14.4074 17.7418 15 16.25 15C14.7582 15 13.3274 14.4074 12.2725 13.3525C11.2176 12.2976 10.625 10.8668 10.625 9.375C10.625 7.88316 11.2176 6.45242 12.2725 5.39752C13.3274 4.34263 14.7582 3.75 16.25 3.75ZM16.25 17.8125C22.4656 17.8125 27.5 20.3297 27.5 23.4375V26.25H5V23.4375C5 20.3297 10.0344 17.8125 16.25 17.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFigmaIcon);
export default __webpack_public_path__ + "static/media/ProfileFigmaIcon.e0ca8ab1ba1c4b44a71ca8546be525f6.svg";
export { ForwardRef as ReactComponent };